var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-privileges-overview container" },
    [
      _c("div", { staticClass: "booking-privileges-overview-header" }, [
        _c("h6", { staticClass: "title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.tc("booking.privilegesOverviewTitle")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.tc("booking.privilegesOverviewSubtitle")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.cartPending && _vm.bookingReady
        ? _c(
            "div",
            { staticClass: "booking-privileges-overview-body" },
            _vm._l(_vm.itemsInCart, function (stay, i) {
              return _c("privilege-overview-card", {
                key: stay.id,
                attrs: { stay: stay, index: i + 1 },
              })
            }),
            1
          )
        : _c("loading-dots"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }